/**
 * Concatenates class names into a single string, filtering out non-string values.
 */
export function csx(...classnames: unknown[]): string {
  return classnames.filter(isString).join(" ");
}

const isString = (x: unknown): boolean =>
  typeof x === "string" || x instanceof String;
